import api from '../services/api';

export interface EquipmentStats {
  available_count: number;
  rented_count: number;
  maintenance_count: number;
  total_count: number;
}

export interface CalendarEvent {
  date: string;
  event_type: string;
  equipment_name: string;
  equipment_type: string;
  license_plate?: string;
  department_name: string;
  status: string;
  time_period: string;
  need_driver: boolean;
  display_text: string;
}

export interface Announcement {
  maintenance_notice?: string;
  new_features?: string;
  usage_reminder?: string;
  created_at?: string;
}

export interface RecentRental {
  id: number;
  equipment_name: string;
  equipment_type: string;
  status: string;
  rental_date: string;
  return_date: string;
  user_name: string;
  created_at: string;
}

export interface DashboardData {
  equipment_stats: EquipmentStats;
  announcement: Announcement | null;
  calendar_events: CalendarEvent[];
  recent_rentals: RecentRental[];
}

export const dashboardAPI = {
  // 獲取儀表板數據
  getDashboardData: async (): Promise<DashboardData> => {
    const response = await api.get('/dashboard/');
    return response.data;
  }
};

// 確保這是一個模組
export {};
